"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var registry_1 = require("../shared/registry");
var SchemaForm_1 = require("./SchemaForm");
var schema_1 = require("../shared/schema");
var virtual_render_1 = require("../shared/virtual-render");
var env = {
    nonameId: 0
};
exports.MarkupContext = react_1.createContext(null);
var getRandomName = function () {
    return "NO_NAME_FIELD_$" + env.nonameId++;
};
exports.SchemaMarkupField = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var parentSchema = react_1.useContext(exports.MarkupContext);
    if (!parentSchema)
        return react_1.default.createElement(react_1.Fragment, null);
    if (parentSchema.isObject()) {
        props.name = props.name || getRandomName();
        var schema = parentSchema.setProperty(props.name, props);
        if (typeof children === 'string') {
            schema['x-component-props'].children = children;
        }
        return (react_1.default.createElement(exports.MarkupContext.Provider, { value: schema }, children));
    }
    else if (parentSchema.isArray()) {
        var schema = parentSchema.setArrayItems(props);
        return (react_1.default.createElement(exports.MarkupContext.Provider, { value: schema }, children));
    }
    else {
        return children || react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.SchemaMarkupField.displayName = 'SchemaMarkupField';
exports.SchemaMarkupForm = function (props) {
    var alreadyHasSchema = false;
    var finalSchema;
    if (props.schema) {
        alreadyHasSchema = true;
        finalSchema = new schema_1.Schema(props.schema);
    }
    else {
        finalSchema = new schema_1.Schema({ type: 'object' });
    }
    env.nonameId = 0;
    return (react_1.default.createElement(react_1.Fragment, null,
        !alreadyHasSchema &&
            virtual_render_1.render(react_1.default.createElement(exports.MarkupContext.Provider, { value: finalSchema }, props.children)),
        react_1.default.createElement(SchemaForm_1.SchemaForm, __assign({}, props, { schema: finalSchema }))));
};
exports.SchemaMarkupForm.displayName = 'SchemaMarkupForm';
var __VIRTUAL_BOX__ = '__VIRTUAL_BOX__';
function createVirtualBox(key, component) {
    var finalComponent = component
        ? function (_a) {
            var schema = _a.schema, children = _a.children;
            var props = schema.getExtendsComponentProps();
            return react_1.default.createElement(component, __assign({ children: children }, props));
        }
        : function () { return react_1.default.createElement(react_1.Fragment, null); };
    registry_1.registerVirtualBox(key, finalComponent);
    var VirtualBox = function (_a) {
        var children = _a.children, name = _a.name, visible = _a.visible, display = _a.display, props = __rest(_a, ["children", "name", "visible", "display"]);
        return (react_1.default.createElement(exports.SchemaMarkupField, { type: "object", name: name, visible: visible, display: display, "x-component": key, "x-component-props": props }, children));
    };
    VirtualBox[__VIRTUAL_BOX__] = { key: key, component: finalComponent };
    return VirtualBox;
}
exports.createVirtualBox = createVirtualBox;
function createControllerBox(key, component) {
    var finalComponent = component ? component : function () { return react_1.default.createElement(react_1.Fragment, null); };
    registry_1.registerVirtualBox(key, finalComponent);
    var VirtualBox = function (_a) {
        var children = _a.children, name = _a.name, props = __rest(_a, ["children", "name"]);
        return (react_1.default.createElement(exports.SchemaMarkupField, { type: "object", name: name, "x-component": key, "x-component-props": props }, children));
    };
    VirtualBox[__VIRTUAL_BOX__] = { key: key, component: finalComponent };
    return VirtualBox;
}
exports.createControllerBox = createControllerBox;
exports.FormSlot = function (_a) {
    var name = _a.name, children = _a.children;
    return (react_1.default.createElement(exports.SchemaMarkupField, { type: "object", name: name, "x-render": function () {
            return react_1.default.createElement(react_1.Fragment, null, children);
        } }));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-schema-renderer/lib/components/SchemaMarkup.js
// module id = 5779
// module chunks = 0